import React from 'react'
import { Container } from 'reactstrap';
// import EmployeesContainer from '../components/Employees/EmployeesContainer';
import EmployeeTabs from '../components/Employees/EmployeeTabs';
import 'bootstrap/dist/css/bootstrap.css';

class Employees extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            employees: [],
            teams: [],
            departments: [],
            clientId: 0
        };

    }

    componentDidMount = () => {
        this.props.log('Employees.js/componentDidMount');
        this.getEmployees();
        this.getTeams();
        this.getDepartments();
    }

    getEmployees = () => {
        this.props.log('Employees.js/getEmployees');
        fetch('/api/employees/' , {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        employees: results.data
                    });
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getTeams = () => {
        this.props.log('Employees.js/getTeams');
        fetch('/api/teams/' , {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        teams: results.data
                    });
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getDepartments = () => {
        this.props.log('Employees.js/getDepartments');
        fetch('/api/departments/' , {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        departments: results.data
                    });
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    render = () => {
        this.props.info('Employees.js/render');
        return (
            <>
                <Container>
                    <EmployeeTabs
                        {...this.props}
                        employees={this.state.employees}
                        teams={this.state.teams}
                        departments={this.state.departments}
                        clientId={this.state.clientId}
                        getEmployees={this.getEmployees}
                        getTeams={this.getTeams}
                        getDepartments={this.getDepartments}
                    />
                </Container>
            </>
        )
    }
}

export default Employees;